// @generated by protoc-gen-es v2.5.1 with parameter "target=ts,json_types=true"
// @generated from file webhooks/v1/service.proto (package webhooks.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { FieldMask, FieldMaskJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Endpoint, EndpointCustomHeader, EndpointCustomHeaderJson, EndpointJson, EndpointSecret, EndpointSecretJson, EndpointStats, EndpointStatsJson, EventType, EventTypeJson, Message as Message$1, MessageAttempt, MessageAttemptJson, MessageJson, Receiver, ReceiverJson } from "./webhook_pb";
import { file_webhooks_v1_webhook } from "./webhook_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file webhooks/v1/service.proto.
 */
export const file_webhooks_v1_service: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_common_v1_pagination, file_google_api_annotations, file_google_protobuf_field_mask, file_google_protobuf_timestamp, file_webhooks_v1_webhook],
	);

/**
 * @generated from message webhooks.v1.CreateReceiverRequest
 */
export type CreateReceiverRequest = Message<"webhooks.v1.CreateReceiverRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;
};

/**
 * @generated from message webhooks.v1.CreateReceiverRequest
 */
export type CreateReceiverRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;
};

/**
 * Describes the message webhooks.v1.CreateReceiverRequest.
 * Use `create(CreateReceiverRequestSchema)` to create a new message.
 */
export const CreateReceiverRequestSchema: GenMessage<CreateReceiverRequest, { jsonType: CreateReceiverRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 0);

/**
 * @generated from message webhooks.v1.CreateWorkspaceReceiverRequest
 */
export type CreateWorkspaceReceiverRequest = Message<"webhooks.v1.CreateWorkspaceReceiverRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;
};

/**
 * @generated from message webhooks.v1.CreateWorkspaceReceiverRequest
 */
export type CreateWorkspaceReceiverRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;
};

/**
 * Describes the message webhooks.v1.CreateWorkspaceReceiverRequest.
 * Use `create(CreateWorkspaceReceiverRequestSchema)` to create a new message.
 */
export const CreateWorkspaceReceiverRequestSchema: GenMessage<CreateWorkspaceReceiverRequest, { jsonType: CreateWorkspaceReceiverRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 1);

/**
 * @generated from message webhooks.v1.CreateWorkspaceReceiverResponse
 */
export type CreateWorkspaceReceiverResponse = Message<"webhooks.v1.CreateWorkspaceReceiverResponse"> & {
	/**
	 * @generated from field: webhooks.v1.Receiver receiver = 1;
	 */
	receiver?: Receiver;
};

/**
 * @generated from message webhooks.v1.CreateWorkspaceReceiverResponse
 */
export type CreateWorkspaceReceiverResponseJson = {
	/**
	 * @generated from field: webhooks.v1.Receiver receiver = 1;
	 */
	receiver?: ReceiverJson;
};

/**
 * Describes the message webhooks.v1.CreateWorkspaceReceiverResponse.
 * Use `create(CreateWorkspaceReceiverResponseSchema)` to create a new message.
 */
export const CreateWorkspaceReceiverResponseSchema: GenMessage<CreateWorkspaceReceiverResponse, { jsonType: CreateWorkspaceReceiverResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 2);

/**
 * @generated from message webhooks.v1.CreateReceiverResponse
 */
export type CreateReceiverResponse = Message<"webhooks.v1.CreateReceiverResponse"> & {
	/**
	 * @generated from field: webhooks.v1.Receiver receiver = 1;
	 */
	receiver?: Receiver;
};

/**
 * @generated from message webhooks.v1.CreateReceiverResponse
 */
export type CreateReceiverResponseJson = {
	/**
	 * @generated from field: webhooks.v1.Receiver receiver = 1;
	 */
	receiver?: ReceiverJson;
};

/**
 * Describes the message webhooks.v1.CreateReceiverResponse.
 * Use `create(CreateReceiverResponseSchema)` to create a new message.
 */
export const CreateReceiverResponseSchema: GenMessage<CreateReceiverResponse, { jsonType: CreateReceiverResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 3);

/**
 * @generated from message webhooks.v1.GetReceiverRequest
 */
export type GetReceiverRequest = Message<"webhooks.v1.GetReceiverRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message webhooks.v1.GetReceiverRequest
 */
export type GetReceiverRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message webhooks.v1.GetReceiverRequest.
 * Use `create(GetReceiverRequestSchema)` to create a new message.
 */
export const GetReceiverRequestSchema: GenMessage<GetReceiverRequest, { jsonType: GetReceiverRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 4);

/**
 * @generated from message webhooks.v1.GetReceiverResponse
 */
export type GetReceiverResponse = Message<"webhooks.v1.GetReceiverResponse"> & {
	/**
	 * @generated from field: webhooks.v1.Receiver receiver = 1;
	 */
	receiver?: Receiver;
};

/**
 * @generated from message webhooks.v1.GetReceiverResponse
 */
export type GetReceiverResponseJson = {
	/**
	 * @generated from field: webhooks.v1.Receiver receiver = 1;
	 */
	receiver?: ReceiverJson;
};

/**
 * Describes the message webhooks.v1.GetReceiverResponse.
 * Use `create(GetReceiverResponseSchema)` to create a new message.
 */
export const GetReceiverResponseSchema: GenMessage<GetReceiverResponse, { jsonType: GetReceiverResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 5);

/**
 * @generated from message webhooks.v1.UpdateReceiverRequest
 */
export type UpdateReceiverRequest = Message<"webhooks.v1.UpdateReceiverRequest"> & {
	/**
	 * @generated from field: webhooks.v1.Receiver receiver = 2;
	 */
	receiver?: Receiver;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 3;
	 */
	mask?: FieldMask;
};

/**
 * @generated from message webhooks.v1.UpdateReceiverRequest
 */
export type UpdateReceiverRequestJson = {
	/**
	 * @generated from field: webhooks.v1.Receiver receiver = 2;
	 */
	receiver?: ReceiverJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 3;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message webhooks.v1.UpdateReceiverRequest.
 * Use `create(UpdateReceiverRequestSchema)` to create a new message.
 */
export const UpdateReceiverRequestSchema: GenMessage<UpdateReceiverRequest, { jsonType: UpdateReceiverRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 6);

/**
 * @generated from message webhooks.v1.UpdateReceiverResponse
 */
export type UpdateReceiverResponse = Message<"webhooks.v1.UpdateReceiverResponse"> & {
	/**
	 * @generated from field: webhooks.v1.Receiver receiver = 1;
	 */
	receiver?: Receiver;
};

/**
 * @generated from message webhooks.v1.UpdateReceiverResponse
 */
export type UpdateReceiverResponseJson = {
	/**
	 * @generated from field: webhooks.v1.Receiver receiver = 1;
	 */
	receiver?: ReceiverJson;
};

/**
 * Describes the message webhooks.v1.UpdateReceiverResponse.
 * Use `create(UpdateReceiverResponseSchema)` to create a new message.
 */
export const UpdateReceiverResponseSchema: GenMessage<UpdateReceiverResponse, { jsonType: UpdateReceiverResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 7);

/**
 * @generated from message webhooks.v1.DeleteReceiverRequest
 */
export type DeleteReceiverRequest = Message<"webhooks.v1.DeleteReceiverRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message webhooks.v1.DeleteReceiverRequest
 */
export type DeleteReceiverRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message webhooks.v1.DeleteReceiverRequest.
 * Use `create(DeleteReceiverRequestSchema)` to create a new message.
 */
export const DeleteReceiverRequestSchema: GenMessage<DeleteReceiverRequest, { jsonType: DeleteReceiverRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 8);

/**
 * @generated from message webhooks.v1.DeleteReceiverResponse
 */
export type DeleteReceiverResponse = Message<"webhooks.v1.DeleteReceiverResponse"> & {};

/**
 * @generated from message webhooks.v1.DeleteReceiverResponse
 */
export type DeleteReceiverResponseJson = {};

/**
 * Describes the message webhooks.v1.DeleteReceiverResponse.
 * Use `create(DeleteReceiverResponseSchema)` to create a new message.
 */
export const DeleteReceiverResponseSchema: GenMessage<DeleteReceiverResponse, { jsonType: DeleteReceiverResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 9);

/**
 * @generated from message webhooks.v1.GetReceiverDashboardRequest
 */
export type GetReceiverDashboardRequest = Message<"webhooks.v1.GetReceiverDashboardRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;
};

/**
 * @generated from message webhooks.v1.GetReceiverDashboardRequest
 */
export type GetReceiverDashboardRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;
};

/**
 * Describes the message webhooks.v1.GetReceiverDashboardRequest.
 * Use `create(GetReceiverDashboardRequestSchema)` to create a new message.
 */
export const GetReceiverDashboardRequestSchema: GenMessage<GetReceiverDashboardRequest, { jsonType: GetReceiverDashboardRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 10);

/**
 * @generated from message webhooks.v1.GetReceiverDashboardResponse
 */
export type GetReceiverDashboardResponse = Message<"webhooks.v1.GetReceiverDashboardResponse"> & {
	/**
	 * @generated from field: string dashboard_url = 1;
	 */
	dashboardUrl: string;
};

/**
 * @generated from message webhooks.v1.GetReceiverDashboardResponse
 */
export type GetReceiverDashboardResponseJson = {
	/**
	 * @generated from field: string dashboard_url = 1;
	 */
	dashboardUrl?: string;
};

/**
 * Describes the message webhooks.v1.GetReceiverDashboardResponse.
 * Use `create(GetReceiverDashboardResponseSchema)` to create a new message.
 */
export const GetReceiverDashboardResponseSchema: GenMessage<GetReceiverDashboardResponse, { jsonType: GetReceiverDashboardResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 11);

/**
 * @generated from message webhooks.v1.ListEndpointsForReceiverRequest
 */
export type ListEndpointsForReceiverRequest = Message<"webhooks.v1.ListEndpointsForReceiverRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 2;
	 */
	pagination?: PaginationArguments;
};

/**
 * @generated from message webhooks.v1.ListEndpointsForReceiverRequest
 */
export type ListEndpointsForReceiverRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 2;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message webhooks.v1.ListEndpointsForReceiverRequest.
 * Use `create(ListEndpointsForReceiverRequestSchema)` to create a new message.
 */
export const ListEndpointsForReceiverRequestSchema: GenMessage<ListEndpointsForReceiverRequest, { jsonType: ListEndpointsForReceiverRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 12);

/**
 * @generated from message webhooks.v1.ListEndpointsForReceiverResponse
 */
export type ListEndpointsForReceiverResponse = Message<"webhooks.v1.ListEndpointsForReceiverResponse"> & {
	/**
	 * @generated from field: repeated webhooks.v1.Endpoint endpoints = 1;
	 */
	endpoints: Endpoint[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message webhooks.v1.ListEndpointsForReceiverResponse
 */
export type ListEndpointsForReceiverResponseJson = {
	/**
	 * @generated from field: repeated webhooks.v1.Endpoint endpoints = 1;
	 */
	endpoints?: EndpointJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message webhooks.v1.ListEndpointsForReceiverResponse.
 * Use `create(ListEndpointsForReceiverResponseSchema)` to create a new message.
 */
export const ListEndpointsForReceiverResponseSchema: GenMessage<ListEndpointsForReceiverResponse, { jsonType: ListEndpointsForReceiverResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 13);

/**
 * @generated from message webhooks.v1.CreateEndpointRequest
 */
export type CreateEndpointRequest = Message<"webhooks.v1.CreateEndpointRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string description = 2;
	 */
	description: string;

	/**
	 * @generated from field: string receiver_id = 3;
	 */
	receiverId: string;

	/**
	 * @generated from field: string url = 4;
	 */
	url: string;

	/**
	 * @generated from field: int32 rate_limit = 5;
	 */
	rateLimit: number;

	/**
	 * @generated from field: repeated string filter_types = 6;
	 */
	filterTypes: string[];
};

/**
 * @generated from message webhooks.v1.CreateEndpointRequest
 */
export type CreateEndpointRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string description = 2;
	 */
	description?: string;

	/**
	 * @generated from field: string receiver_id = 3;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string url = 4;
	 */
	url?: string;

	/**
	 * @generated from field: int32 rate_limit = 5;
	 */
	rateLimit?: number;

	/**
	 * @generated from field: repeated string filter_types = 6;
	 */
	filterTypes?: string[];
};

/**
 * Describes the message webhooks.v1.CreateEndpointRequest.
 * Use `create(CreateEndpointRequestSchema)` to create a new message.
 */
export const CreateEndpointRequestSchema: GenMessage<CreateEndpointRequest, { jsonType: CreateEndpointRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 14);

/**
 * @generated from message webhooks.v1.GetEndpointRequest
 */
export type GetEndpointRequest = Message<"webhooks.v1.GetEndpointRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;
};

/**
 * @generated from message webhooks.v1.GetEndpointRequest
 */
export type GetEndpointRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;
};

/**
 * Describes the message webhooks.v1.GetEndpointRequest.
 * Use `create(GetEndpointRequestSchema)` to create a new message.
 */
export const GetEndpointRequestSchema: GenMessage<GetEndpointRequest, { jsonType: GetEndpointRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 15);

/**
 * @generated from message webhooks.v1.GetEndpointResponse
 */
export type GetEndpointResponse = Message<"webhooks.v1.GetEndpointResponse"> & {
	/**
	 * @generated from field: webhooks.v1.Endpoint endpoint = 1;
	 */
	endpoint?: Endpoint;
};

/**
 * @generated from message webhooks.v1.GetEndpointResponse
 */
export type GetEndpointResponseJson = {
	/**
	 * @generated from field: webhooks.v1.Endpoint endpoint = 1;
	 */
	endpoint?: EndpointJson;
};

/**
 * Describes the message webhooks.v1.GetEndpointResponse.
 * Use `create(GetEndpointResponseSchema)` to create a new message.
 */
export const GetEndpointResponseSchema: GenMessage<GetEndpointResponse, { jsonType: GetEndpointResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 16);

/**
 * @generated from message webhooks.v1.CreateEndpointResponse
 */
export type CreateEndpointResponse = Message<"webhooks.v1.CreateEndpointResponse"> & {
	/**
	 * @generated from field: webhooks.v1.Endpoint endpoint = 1;
	 */
	endpoint?: Endpoint;
};

/**
 * @generated from message webhooks.v1.CreateEndpointResponse
 */
export type CreateEndpointResponseJson = {
	/**
	 * @generated from field: webhooks.v1.Endpoint endpoint = 1;
	 */
	endpoint?: EndpointJson;
};

/**
 * Describes the message webhooks.v1.CreateEndpointResponse.
 * Use `create(CreateEndpointResponseSchema)` to create a new message.
 */
export const CreateEndpointResponseSchema: GenMessage<CreateEndpointResponse, { jsonType: CreateEndpointResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 17);

/**
 * @generated from message webhooks.v1.DeleteEndpointRequest
 */
export type DeleteEndpointRequest = Message<"webhooks.v1.DeleteEndpointRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;
};

/**
 * @generated from message webhooks.v1.DeleteEndpointRequest
 */
export type DeleteEndpointRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;
};

/**
 * Describes the message webhooks.v1.DeleteEndpointRequest.
 * Use `create(DeleteEndpointRequestSchema)` to create a new message.
 */
export const DeleteEndpointRequestSchema: GenMessage<DeleteEndpointRequest, { jsonType: DeleteEndpointRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 18);

/**
 * @generated from message webhooks.v1.DeleteEndpointResponse
 */
export type DeleteEndpointResponse = Message<"webhooks.v1.DeleteEndpointResponse"> & {};

/**
 * @generated from message webhooks.v1.DeleteEndpointResponse
 */
export type DeleteEndpointResponseJson = {};

/**
 * Describes the message webhooks.v1.DeleteEndpointResponse.
 * Use `create(DeleteEndpointResponseSchema)` to create a new message.
 */
export const DeleteEndpointResponseSchema: GenMessage<DeleteEndpointResponse, { jsonType: DeleteEndpointResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 19);

/**
 * @generated from message webhooks.v1.UpdateEndpointRequest
 */
export type UpdateEndpointRequest = Message<"webhooks.v1.UpdateEndpointRequest"> & {
	/**
	 * @generated from field: webhooks.v1.Endpoint endpoint = 1;
	 */
	endpoint?: Endpoint;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask;
};

/**
 * @generated from message webhooks.v1.UpdateEndpointRequest
 */
export type UpdateEndpointRequestJson = {
	/**
	 * @generated from field: webhooks.v1.Endpoint endpoint = 1;
	 */
	endpoint?: EndpointJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message webhooks.v1.UpdateEndpointRequest.
 * Use `create(UpdateEndpointRequestSchema)` to create a new message.
 */
export const UpdateEndpointRequestSchema: GenMessage<UpdateEndpointRequest, { jsonType: UpdateEndpointRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 20);

/**
 * @generated from message webhooks.v1.UpdateEndpointResponse
 */
export type UpdateEndpointResponse = Message<"webhooks.v1.UpdateEndpointResponse"> & {
	/**
	 * @generated from field: webhooks.v1.Endpoint endpoint = 1;
	 */
	endpoint?: Endpoint;
};

/**
 * @generated from message webhooks.v1.UpdateEndpointResponse
 */
export type UpdateEndpointResponseJson = {
	/**
	 * @generated from field: webhooks.v1.Endpoint endpoint = 1;
	 */
	endpoint?: EndpointJson;
};

/**
 * Describes the message webhooks.v1.UpdateEndpointResponse.
 * Use `create(UpdateEndpointResponseSchema)` to create a new message.
 */
export const UpdateEndpointResponseSchema: GenMessage<UpdateEndpointResponse, { jsonType: UpdateEndpointResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 21);

/**
 * @generated from message webhooks.v1.ListMessagesForReceiverRequest
 */
export type ListMessagesForReceiverRequest = Message<"webhooks.v1.ListMessagesForReceiverRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 2;
	 */
	pagination?: PaginationArguments;

	/**
	 * @generated from field: bool exclude_content = 3;
	 */
	excludeContent: boolean;

	/**
	 * @generated from field: repeated string event_types = 4;
	 */
	eventTypes: string[];

	/**
	 * @generated from field: string channel = 5;
	 */
	channel: string;

	/**
	 * @generated from field: string tag = 6;
	 */
	tag: string;
};

/**
 * @generated from message webhooks.v1.ListMessagesForReceiverRequest
 */
export type ListMessagesForReceiverRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 2;
	 */
	pagination?: PaginationArgumentsJson;

	/**
	 * @generated from field: bool exclude_content = 3;
	 */
	excludeContent?: boolean;

	/**
	 * @generated from field: repeated string event_types = 4;
	 */
	eventTypes?: string[];

	/**
	 * @generated from field: string channel = 5;
	 */
	channel?: string;

	/**
	 * @generated from field: string tag = 6;
	 */
	tag?: string;
};

/**
 * Describes the message webhooks.v1.ListMessagesForReceiverRequest.
 * Use `create(ListMessagesForReceiverRequestSchema)` to create a new message.
 */
export const ListMessagesForReceiverRequestSchema: GenMessage<ListMessagesForReceiverRequest, { jsonType: ListMessagesForReceiverRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 22);

/**
 * @generated from message webhooks.v1.ListMessagesForReceiverResponse
 */
export type ListMessagesForReceiverResponse = Message<"webhooks.v1.ListMessagesForReceiverResponse"> & {
	/**
	 * @generated from field: repeated webhooks.v1.Message messages = 1;
	 */
	messages: Message$1[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message webhooks.v1.ListMessagesForReceiverResponse
 */
export type ListMessagesForReceiverResponseJson = {
	/**
	 * @generated from field: repeated webhooks.v1.Message messages = 1;
	 */
	messages?: MessageJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message webhooks.v1.ListMessagesForReceiverResponse.
 * Use `create(ListMessagesForReceiverResponseSchema)` to create a new message.
 */
export const ListMessagesForReceiverResponseSchema: GenMessage<ListMessagesForReceiverResponse, { jsonType: ListMessagesForReceiverResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 23);

/**
 * @generated from message webhooks.v1.GetMessageRequest
 */
export type GetMessageRequest = Message<"webhooks.v1.GetMessageRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string message_id = 2;
	 */
	messageId: string;

	/**
	 * Optionally exclude the message content.
	 * Setting this to true will return a message with a nil payload.
	 *
	 * @generated from field: bool exclude_content = 3;
	 */
	excludeContent: boolean;
};

/**
 * @generated from message webhooks.v1.GetMessageRequest
 */
export type GetMessageRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string message_id = 2;
	 */
	messageId?: string;

	/**
	 * Optionally exclude the message content.
	 * Setting this to true will return a message with a nil payload.
	 *
	 * @generated from field: bool exclude_content = 3;
	 */
	excludeContent?: boolean;
};

/**
 * Describes the message webhooks.v1.GetMessageRequest.
 * Use `create(GetMessageRequestSchema)` to create a new message.
 */
export const GetMessageRequestSchema: GenMessage<GetMessageRequest, { jsonType: GetMessageRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 24);

/**
 * @generated from message webhooks.v1.GetMessageResponse
 */
export type GetMessageResponse = Message<"webhooks.v1.GetMessageResponse"> & {
	/**
	 * @generated from field: webhooks.v1.Message message = 1;
	 */
	message?: Message$1;
};

/**
 * @generated from message webhooks.v1.GetMessageResponse
 */
export type GetMessageResponseJson = {
	/**
	 * @generated from field: webhooks.v1.Message message = 1;
	 */
	message?: MessageJson;
};

/**
 * Describes the message webhooks.v1.GetMessageResponse.
 * Use `create(GetMessageResponseSchema)` to create a new message.
 */
export const GetMessageResponseSchema: GenMessage<GetMessageResponse, { jsonType: GetMessageResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 25);

/**
 * @generated from message webhooks.v1.ListMessageAttemptsForEndpointRequest
 */
export type ListMessageAttemptsForEndpointRequest = Message<"webhooks.v1.ListMessageAttemptsForEndpointRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArguments;

	/**
	 * @generated from field: bool with_msg = 4;
	 */
	withMsg: boolean;
};

/**
 * @generated from message webhooks.v1.ListMessageAttemptsForEndpointRequest
 */
export type ListMessageAttemptsForEndpointRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArgumentsJson;

	/**
	 * @generated from field: bool with_msg = 4;
	 */
	withMsg?: boolean;
};

/**
 * Describes the message webhooks.v1.ListMessageAttemptsForEndpointRequest.
 * Use `create(ListMessageAttemptsForEndpointRequestSchema)` to create a new message.
 */
export const ListMessageAttemptsForEndpointRequestSchema: GenMessage<ListMessageAttemptsForEndpointRequest, { jsonType: ListMessageAttemptsForEndpointRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 26);

/**
 * @generated from message webhooks.v1.ListMessageAttemptsForEndpointResponse
 */
export type ListMessageAttemptsForEndpointResponse = Message<"webhooks.v1.ListMessageAttemptsForEndpointResponse"> & {
	/**
	 * @generated from field: repeated webhooks.v1.MessageAttempt message_attempts = 1;
	 */
	messageAttempts: MessageAttempt[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message webhooks.v1.ListMessageAttemptsForEndpointResponse
 */
export type ListMessageAttemptsForEndpointResponseJson = {
	/**
	 * @generated from field: repeated webhooks.v1.MessageAttempt message_attempts = 1;
	 */
	messageAttempts?: MessageAttemptJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message webhooks.v1.ListMessageAttemptsForEndpointResponse.
 * Use `create(ListMessageAttemptsForEndpointResponseSchema)` to create a new message.
 */
export const ListMessageAttemptsForEndpointResponseSchema: GenMessage<ListMessageAttemptsForEndpointResponse, { jsonType: ListMessageAttemptsForEndpointResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 27);

/**
 * @generated from message webhooks.v1.GetEndpointSecretRequest
 */
export type GetEndpointSecretRequest = Message<"webhooks.v1.GetEndpointSecretRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;
};

/**
 * @generated from message webhooks.v1.GetEndpointSecretRequest
 */
export type GetEndpointSecretRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;
};

/**
 * Describes the message webhooks.v1.GetEndpointSecretRequest.
 * Use `create(GetEndpointSecretRequestSchema)` to create a new message.
 */
export const GetEndpointSecretRequestSchema: GenMessage<GetEndpointSecretRequest, { jsonType: GetEndpointSecretRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 28);

/**
 * @generated from message webhooks.v1.GetEndpointSecretResponse
 */
export type GetEndpointSecretResponse = Message<"webhooks.v1.GetEndpointSecretResponse"> & {
	/**
	 * @generated from field: webhooks.v1.EndpointSecret secret = 1;
	 */
	secret?: EndpointSecret;
};

/**
 * @generated from message webhooks.v1.GetEndpointSecretResponse
 */
export type GetEndpointSecretResponseJson = {
	/**
	 * @generated from field: webhooks.v1.EndpointSecret secret = 1;
	 */
	secret?: EndpointSecretJson;
};

/**
 * Describes the message webhooks.v1.GetEndpointSecretResponse.
 * Use `create(GetEndpointSecretResponseSchema)` to create a new message.
 */
export const GetEndpointSecretResponseSchema: GenMessage<GetEndpointSecretResponse, { jsonType: GetEndpointSecretResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 29);

/**
 * @generated from message webhooks.v1.RotateEndpointSecretRequest
 */
export type RotateEndpointSecretRequest = Message<"webhooks.v1.RotateEndpointSecretRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;
};

/**
 * @generated from message webhooks.v1.RotateEndpointSecretRequest
 */
export type RotateEndpointSecretRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;
};

/**
 * Describes the message webhooks.v1.RotateEndpointSecretRequest.
 * Use `create(RotateEndpointSecretRequestSchema)` to create a new message.
 */
export const RotateEndpointSecretRequestSchema: GenMessage<RotateEndpointSecretRequest, { jsonType: RotateEndpointSecretRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 30);

/**
 * @generated from message webhooks.v1.RotateEndpointSecretResponse
 */
export type RotateEndpointSecretResponse = Message<"webhooks.v1.RotateEndpointSecretResponse"> & {};

/**
 * @generated from message webhooks.v1.RotateEndpointSecretResponse
 */
export type RotateEndpointSecretResponseJson = {};

/**
 * Describes the message webhooks.v1.RotateEndpointSecretResponse.
 * Use `create(RotateEndpointSecretResponseSchema)` to create a new message.
 */
export const RotateEndpointSecretResponseSchema: GenMessage<RotateEndpointSecretResponse, { jsonType: RotateEndpointSecretResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 31);

/**
 * @generated from message webhooks.v1.ListEndpointCustomHeadersRequest
 */
export type ListEndpointCustomHeadersRequest = Message<"webhooks.v1.ListEndpointCustomHeadersRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;
};

/**
 * @generated from message webhooks.v1.ListEndpointCustomHeadersRequest
 */
export type ListEndpointCustomHeadersRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;
};

/**
 * Describes the message webhooks.v1.ListEndpointCustomHeadersRequest.
 * Use `create(ListEndpointCustomHeadersRequestSchema)` to create a new message.
 */
export const ListEndpointCustomHeadersRequestSchema: GenMessage<ListEndpointCustomHeadersRequest, { jsonType: ListEndpointCustomHeadersRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 32);

/**
 * @generated from message webhooks.v1.ListEndpointCustomHeadersResponse
 */
export type ListEndpointCustomHeadersResponse = Message<"webhooks.v1.ListEndpointCustomHeadersResponse"> & {
	/**
	 * @generated from field: repeated webhooks.v1.EndpointCustomHeader headers = 1;
	 */
	headers: EndpointCustomHeader[];
};

/**
 * @generated from message webhooks.v1.ListEndpointCustomHeadersResponse
 */
export type ListEndpointCustomHeadersResponseJson = {
	/**
	 * @generated from field: repeated webhooks.v1.EndpointCustomHeader headers = 1;
	 */
	headers?: EndpointCustomHeaderJson[];
};

/**
 * Describes the message webhooks.v1.ListEndpointCustomHeadersResponse.
 * Use `create(ListEndpointCustomHeadersResponseSchema)` to create a new message.
 */
export const ListEndpointCustomHeadersResponseSchema: GenMessage<ListEndpointCustomHeadersResponse, { jsonType: ListEndpointCustomHeadersResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 33);

/**
 * @generated from message webhooks.v1.UpdateEndpointCustomHeadersRequest
 */
export type UpdateEndpointCustomHeadersRequest = Message<"webhooks.v1.UpdateEndpointCustomHeadersRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;

	/**
	 * @generated from field: map<string, string> headers = 3;
	 */
	headers: { [key: string]: string };
};

/**
 * @generated from message webhooks.v1.UpdateEndpointCustomHeadersRequest
 */
export type UpdateEndpointCustomHeadersRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;

	/**
	 * @generated from field: map<string, string> headers = 3;
	 */
	headers?: { [key: string]: string };
};

/**
 * Describes the message webhooks.v1.UpdateEndpointCustomHeadersRequest.
 * Use `create(UpdateEndpointCustomHeadersRequestSchema)` to create a new message.
 */
export const UpdateEndpointCustomHeadersRequestSchema: GenMessage<UpdateEndpointCustomHeadersRequest, { jsonType: UpdateEndpointCustomHeadersRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 34);

/**
 * @generated from message webhooks.v1.UpdateEndpointCustomHeadersResponse
 */
export type UpdateEndpointCustomHeadersResponse = Message<"webhooks.v1.UpdateEndpointCustomHeadersResponse"> & {};

/**
 * @generated from message webhooks.v1.UpdateEndpointCustomHeadersResponse
 */
export type UpdateEndpointCustomHeadersResponseJson = {};

/**
 * Describes the message webhooks.v1.UpdateEndpointCustomHeadersResponse.
 * Use `create(UpdateEndpointCustomHeadersResponseSchema)` to create a new message.
 */
export const UpdateEndpointCustomHeadersResponseSchema: GenMessage<UpdateEndpointCustomHeadersResponse, { jsonType: UpdateEndpointCustomHeadersResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 35);

/**
 * @generated from message webhooks.v1.ListEventTypesRequest
 */
export type ListEventTypesRequest = Message<"webhooks.v1.ListEventTypesRequest"> & {
	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArguments;
};

/**
 * @generated from message webhooks.v1.ListEventTypesRequest
 */
export type ListEventTypesRequestJson = {
	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message webhooks.v1.ListEventTypesRequest.
 * Use `create(ListEventTypesRequestSchema)` to create a new message.
 */
export const ListEventTypesRequestSchema: GenMessage<ListEventTypesRequest, { jsonType: ListEventTypesRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 36);

/**
 * @generated from message webhooks.v1.ListEventTypesResponse
 */
export type ListEventTypesResponse = Message<"webhooks.v1.ListEventTypesResponse"> & {
	/**
	 * @generated from field: repeated webhooks.v1.EventType event_types = 1;
	 */
	eventTypes: EventType[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message webhooks.v1.ListEventTypesResponse
 */
export type ListEventTypesResponseJson = {
	/**
	 * @generated from field: repeated webhooks.v1.EventType event_types = 1;
	 */
	eventTypes?: EventTypeJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message webhooks.v1.ListEventTypesResponse.
 * Use `create(ListEventTypesResponseSchema)` to create a new message.
 */
export const ListEventTypesResponseSchema: GenMessage<ListEventTypesResponse, { jsonType: ListEventTypesResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 37);

/**
 * @generated from message webhooks.v1.GetEventTypeRequest
 */
export type GetEventTypeRequest = Message<"webhooks.v1.GetEventTypeRequest"> & {
	/**
	 * @generated from field: string name = 1;
	 */
	name: string;
};

/**
 * @generated from message webhooks.v1.GetEventTypeRequest
 */
export type GetEventTypeRequestJson = {
	/**
	 * @generated from field: string name = 1;
	 */
	name?: string;
};

/**
 * Describes the message webhooks.v1.GetEventTypeRequest.
 * Use `create(GetEventTypeRequestSchema)` to create a new message.
 */
export const GetEventTypeRequestSchema: GenMessage<GetEventTypeRequest, { jsonType: GetEventTypeRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 38);

/**
 * @generated from message webhooks.v1.GetEventTypeResponse
 */
export type GetEventTypeResponse = Message<"webhooks.v1.GetEventTypeResponse"> & {
	/**
	 * @generated from field: webhooks.v1.EventType event_type = 1;
	 */
	eventType?: EventType;
};

/**
 * @generated from message webhooks.v1.GetEventTypeResponse
 */
export type GetEventTypeResponseJson = {
	/**
	 * @generated from field: webhooks.v1.EventType event_type = 1;
	 */
	eventType?: EventTypeJson;
};

/**
 * Describes the message webhooks.v1.GetEventTypeResponse.
 * Use `create(GetEventTypeResponseSchema)` to create a new message.
 */
export const GetEventTypeResponseSchema: GenMessage<GetEventTypeResponse, { jsonType: GetEventTypeResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 39);

/**
 * @generated from message webhooks.v1.GetEndpointStatsRequest
 */
export type GetEndpointStatsRequest = Message<"webhooks.v1.GetEndpointStatsRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;

	/**
	 * @generated from field: google.protobuf.Timestamp since = 3;
	 */
	since?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp until = 4;
	 */
	until?: Timestamp;
};

/**
 * @generated from message webhooks.v1.GetEndpointStatsRequest
 */
export type GetEndpointStatsRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp since = 3;
	 */
	since?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp until = 4;
	 */
	until?: TimestampJson;
};

/**
 * Describes the message webhooks.v1.GetEndpointStatsRequest.
 * Use `create(GetEndpointStatsRequestSchema)` to create a new message.
 */
export const GetEndpointStatsRequestSchema: GenMessage<GetEndpointStatsRequest, { jsonType: GetEndpointStatsRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 40);

/**
 * @generated from message webhooks.v1.GetEndpointStatsResponse
 */
export type GetEndpointStatsResponse = Message<"webhooks.v1.GetEndpointStatsResponse"> & {
	/**
	 * @generated from field: webhooks.v1.EndpointStats stats = 1;
	 */
	stats?: EndpointStats;
};

/**
 * @generated from message webhooks.v1.GetEndpointStatsResponse
 */
export type GetEndpointStatsResponseJson = {
	/**
	 * @generated from field: webhooks.v1.EndpointStats stats = 1;
	 */
	stats?: EndpointStatsJson;
};

/**
 * Describes the message webhooks.v1.GetEndpointStatsResponse.
 * Use `create(GetEndpointStatsResponseSchema)` to create a new message.
 */
export const GetEndpointStatsResponseSchema: GenMessage<GetEndpointStatsResponse, { jsonType: GetEndpointStatsResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 41);

/**
 * @generated from message webhooks.v1.ResendMessageRequest
 */
export type ResendMessageRequest = Message<"webhooks.v1.ResendMessageRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string message_id = 2;
	 */
	messageId: string;

	/**
	 * @generated from field: string endpoint_id = 3;
	 */
	endpointId: string;
};

/**
 * @generated from message webhooks.v1.ResendMessageRequest
 */
export type ResendMessageRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string message_id = 2;
	 */
	messageId?: string;

	/**
	 * @generated from field: string endpoint_id = 3;
	 */
	endpointId?: string;
};

/**
 * Describes the message webhooks.v1.ResendMessageRequest.
 * Use `create(ResendMessageRequestSchema)` to create a new message.
 */
export const ResendMessageRequestSchema: GenMessage<ResendMessageRequest, { jsonType: ResendMessageRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 42);

/**
 * @generated from message webhooks.v1.ResendMessageResponse
 */
export type ResendMessageResponse = Message<"webhooks.v1.ResendMessageResponse"> & {};

/**
 * @generated from message webhooks.v1.ResendMessageResponse
 */
export type ResendMessageResponseJson = {};

/**
 * Describes the message webhooks.v1.ResendMessageResponse.
 * Use `create(ResendMessageResponseSchema)` to create a new message.
 */
export const ResendMessageResponseSchema: GenMessage<ResendMessageResponse, { jsonType: ResendMessageResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 43);

/**
 * @generated from message webhooks.v1.RecoverFailedMessagesForEndpointRequest
 */
export type RecoverFailedMessagesForEndpointRequest = Message<"webhooks.v1.RecoverFailedMessagesForEndpointRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;

	/**
	 * @generated from field: google.protobuf.Timestamp since = 3;
	 */
	since?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp until = 4;
	 */
	until?: Timestamp;
};

/**
 * @generated from message webhooks.v1.RecoverFailedMessagesForEndpointRequest
 */
export type RecoverFailedMessagesForEndpointRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp since = 3;
	 */
	since?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp until = 4;
	 */
	until?: TimestampJson;
};

/**
 * Describes the message webhooks.v1.RecoverFailedMessagesForEndpointRequest.
 * Use `create(RecoverFailedMessagesForEndpointRequestSchema)` to create a new message.
 */
export const RecoverFailedMessagesForEndpointRequestSchema: GenMessage<RecoverFailedMessagesForEndpointRequest, { jsonType: RecoverFailedMessagesForEndpointRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 44);

/**
 * @generated from message webhooks.v1.RecoverFailedMessagesForEndpointResponse
 */
export type RecoverFailedMessagesForEndpointResponse = Message<"webhooks.v1.RecoverFailedMessagesForEndpointResponse"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string status = 2;
	 */
	status: string;

	/**
	 * @generated from field: string task = 3;
	 */
	task: string;
};

/**
 * @generated from message webhooks.v1.RecoverFailedMessagesForEndpointResponse
 */
export type RecoverFailedMessagesForEndpointResponseJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string status = 2;
	 */
	status?: string;

	/**
	 * @generated from field: string task = 3;
	 */
	task?: string;
};

/**
 * Describes the message webhooks.v1.RecoverFailedMessagesForEndpointResponse.
 * Use `create(RecoverFailedMessagesForEndpointResponseSchema)` to create a new message.
 */
export const RecoverFailedMessagesForEndpointResponseSchema: GenMessage<RecoverFailedMessagesForEndpointResponse, { jsonType: RecoverFailedMessagesForEndpointResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 45);

/**
 * @generated from message webhooks.v1.ReplayMissingMessagesForEndpointRequest
 */
export type ReplayMissingMessagesForEndpointRequest = Message<"webhooks.v1.ReplayMissingMessagesForEndpointRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;

	/**
	 * @generated from field: google.protobuf.Timestamp since = 3;
	 */
	since?: Timestamp;

	/**
	 * @generated from field: google.protobuf.Timestamp until = 4;
	 */
	until?: Timestamp;
};

/**
 * @generated from message webhooks.v1.ReplayMissingMessagesForEndpointRequest
 */
export type ReplayMissingMessagesForEndpointRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;

	/**
	 * @generated from field: google.protobuf.Timestamp since = 3;
	 */
	since?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp until = 4;
	 */
	until?: TimestampJson;
};

/**
 * Describes the message webhooks.v1.ReplayMissingMessagesForEndpointRequest.
 * Use `create(ReplayMissingMessagesForEndpointRequestSchema)` to create a new message.
 */
export const ReplayMissingMessagesForEndpointRequestSchema: GenMessage<ReplayMissingMessagesForEndpointRequest, { jsonType: ReplayMissingMessagesForEndpointRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 46);

/**
 * @generated from message webhooks.v1.ReplayMissingMessagesForEndpointResponse
 */
export type ReplayMissingMessagesForEndpointResponse = Message<"webhooks.v1.ReplayMissingMessagesForEndpointResponse"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string status = 2;
	 */
	status: string;

	/**
	 * @generated from field: string task = 3;
	 */
	task: string;
};

/**
 * @generated from message webhooks.v1.ReplayMissingMessagesForEndpointResponse
 */
export type ReplayMissingMessagesForEndpointResponseJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string status = 2;
	 */
	status?: string;

	/**
	 * @generated from field: string task = 3;
	 */
	task?: string;
};

/**
 * Describes the message webhooks.v1.ReplayMissingMessagesForEndpointResponse.
 * Use `create(ReplayMissingMessagesForEndpointResponseSchema)` to create a new message.
 */
export const ReplayMissingMessagesForEndpointResponseSchema: GenMessage<ReplayMissingMessagesForEndpointResponse, { jsonType: ReplayMissingMessagesForEndpointResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 47);

/**
 * @generated from message webhooks.v1.GetEndpointTransformationRequest
 */
export type GetEndpointTransformationRequest = Message<"webhooks.v1.GetEndpointTransformationRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;
};

/**
 * @generated from message webhooks.v1.GetEndpointTransformationRequest
 */
export type GetEndpointTransformationRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;
};

/**
 * Describes the message webhooks.v1.GetEndpointTransformationRequest.
 * Use `create(GetEndpointTransformationRequestSchema)` to create a new message.
 */
export const GetEndpointTransformationRequestSchema: GenMessage<GetEndpointTransformationRequest, { jsonType: GetEndpointTransformationRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 48);

/**
 * @generated from message webhooks.v1.GetEndpointTransformationResponse
 */
export type GetEndpointTransformationResponse = Message<"webhooks.v1.GetEndpointTransformationResponse"> & {
	/**
	 * @generated from field: string code = 1;
	 */
	code: string;

	/**
	 * @generated from field: bool enabled = 2;
	 */
	enabled: boolean;
};

/**
 * @generated from message webhooks.v1.GetEndpointTransformationResponse
 */
export type GetEndpointTransformationResponseJson = {
	/**
	 * @generated from field: string code = 1;
	 */
	code?: string;

	/**
	 * @generated from field: bool enabled = 2;
	 */
	enabled?: boolean;
};

/**
 * Describes the message webhooks.v1.GetEndpointTransformationResponse.
 * Use `create(GetEndpointTransformationResponseSchema)` to create a new message.
 */
export const GetEndpointTransformationResponseSchema: GenMessage<GetEndpointTransformationResponse, { jsonType: GetEndpointTransformationResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 49);

/**
 * @generated from message webhooks.v1.SetEndpointTransformationRequest
 */
export type SetEndpointTransformationRequest = Message<"webhooks.v1.SetEndpointTransformationRequest"> & {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId: string;

	/**
	 * @generated from field: string code = 3;
	 */
	code: string;

	/**
	 * @generated from field: bool enabled = 4;
	 */
	enabled: boolean;
};

/**
 * @generated from message webhooks.v1.SetEndpointTransformationRequest
 */
export type SetEndpointTransformationRequestJson = {
	/**
	 * @generated from field: string receiver_id = 1;
	 */
	receiverId?: string;

	/**
	 * @generated from field: string endpoint_id = 2;
	 */
	endpointId?: string;

	/**
	 * @generated from field: string code = 3;
	 */
	code?: string;

	/**
	 * @generated from field: bool enabled = 4;
	 */
	enabled?: boolean;
};

/**
 * Describes the message webhooks.v1.SetEndpointTransformationRequest.
 * Use `create(SetEndpointTransformationRequestSchema)` to create a new message.
 */
export const SetEndpointTransformationRequestSchema: GenMessage<SetEndpointTransformationRequest, { jsonType: SetEndpointTransformationRequestJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 50);

/**
 * @generated from message webhooks.v1.SetEndpointTransformationResponse
 */
export type SetEndpointTransformationResponse = Message<"webhooks.v1.SetEndpointTransformationResponse"> & {};

/**
 * @generated from message webhooks.v1.SetEndpointTransformationResponse
 */
export type SetEndpointTransformationResponseJson = {};

/**
 * Describes the message webhooks.v1.SetEndpointTransformationResponse.
 * Use `create(SetEndpointTransformationResponseSchema)` to create a new message.
 */
export const SetEndpointTransformationResponseSchema: GenMessage<SetEndpointTransformationResponse, { jsonType: SetEndpointTransformationResponseJson }> = /*@__PURE__*/ messageDesc(file_webhooks_v1_service, 51);

/**
 * @generated from service webhooks.v1.WebhooksService
 */
export const WebhooksService: GenService<{
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.CreateReceiver
	 */
	createReceiver: {
		methodKind: "unary";
		input: typeof CreateReceiverRequestSchema;
		output: typeof CreateReceiverResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.CreateWorkspaceReceiver
	 */
	createWorkspaceReceiver: {
		methodKind: "unary";
		input: typeof CreateWorkspaceReceiverRequestSchema;
		output: typeof CreateWorkspaceReceiverResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.GetReceiver
	 */
	getReceiver: {
		methodKind: "unary";
		input: typeof GetReceiverRequestSchema;
		output: typeof GetReceiverResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.UpdateReceiver
	 */
	updateReceiver: {
		methodKind: "unary";
		input: typeof UpdateReceiverRequestSchema;
		output: typeof UpdateReceiverResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.DeleteReceiver
	 */
	deleteReceiver: {
		methodKind: "unary";
		input: typeof DeleteReceiverRequestSchema;
		output: typeof DeleteReceiverResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.ListEndpointsForReceiver
	 */
	listEndpointsForReceiver: {
		methodKind: "unary";
		input: typeof ListEndpointsForReceiverRequestSchema;
		output: typeof ListEndpointsForReceiverResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.ListMessagesForReceiver
	 */
	listMessagesForReceiver: {
		methodKind: "unary";
		input: typeof ListMessagesForReceiverRequestSchema;
		output: typeof ListMessagesForReceiverResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.GetMessage
	 */
	getMessage: {
		methodKind: "unary";
		input: typeof GetMessageRequestSchema;
		output: typeof GetMessageResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.CreateEndpoint
	 */
	createEndpoint: {
		methodKind: "unary";
		input: typeof CreateEndpointRequestSchema;
		output: typeof CreateEndpointResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.GetEndpoint
	 */
	getEndpoint: {
		methodKind: "unary";
		input: typeof GetEndpointRequestSchema;
		output: typeof GetEndpointResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.UpdateEndpoint
	 */
	updateEndpoint: {
		methodKind: "unary";
		input: typeof UpdateEndpointRequestSchema;
		output: typeof UpdateEndpointResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.DeleteEndpoint
	 */
	deleteEndpoint: {
		methodKind: "unary";
		input: typeof DeleteEndpointRequestSchema;
		output: typeof DeleteEndpointResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.ListMessageAttemptsForEndpoint
	 */
	listMessageAttemptsForEndpoint: {
		methodKind: "unary";
		input: typeof ListMessageAttemptsForEndpointRequestSchema;
		output: typeof ListMessageAttemptsForEndpointResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.GetReceiverDashboard
	 */
	getReceiverDashboard: {
		methodKind: "unary";
		input: typeof GetReceiverDashboardRequestSchema;
		output: typeof GetReceiverDashboardResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.GetEndpointSecret
	 */
	getEndpointSecret: {
		methodKind: "unary";
		input: typeof GetEndpointSecretRequestSchema;
		output: typeof GetEndpointSecretResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.RotateEndpointSecret
	 */
	rotateEndpointSecret: {
		methodKind: "unary";
		input: typeof RotateEndpointSecretRequestSchema;
		output: typeof RotateEndpointSecretResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.UpdateEndpointCustomHeaders
	 */
	updateEndpointCustomHeaders: {
		methodKind: "unary";
		input: typeof UpdateEndpointCustomHeadersRequestSchema;
		output: typeof UpdateEndpointCustomHeadersResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.ListEndpointCustomHeaders
	 */
	listEndpointCustomHeaders: {
		methodKind: "unary";
		input: typeof ListEndpointCustomHeadersRequestSchema;
		output: typeof ListEndpointCustomHeadersResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.ListEventTypes
	 */
	listEventTypes: {
		methodKind: "unary";
		input: typeof ListEventTypesRequestSchema;
		output: typeof ListEventTypesResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.GetEventType
	 */
	getEventType: {
		methodKind: "unary";
		input: typeof GetEventTypeRequestSchema;
		output: typeof GetEventTypeResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.GetEndpointStats
	 */
	getEndpointStats: {
		methodKind: "unary";
		input: typeof GetEndpointStatsRequestSchema;
		output: typeof GetEndpointStatsResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.ResendMessage
	 */
	resendMessage: {
		methodKind: "unary";
		input: typeof ResendMessageRequestSchema;
		output: typeof ResendMessageResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.RecoverFailedMessagesForEndpoint
	 */
	recoverFailedMessagesForEndpoint: {
		methodKind: "unary";
		input: typeof RecoverFailedMessagesForEndpointRequestSchema;
		output: typeof RecoverFailedMessagesForEndpointResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.ReplayMissingMessagesForEndpoint
	 */
	replayMissingMessagesForEndpoint: {
		methodKind: "unary";
		input: typeof ReplayMissingMessagesForEndpointRequestSchema;
		output: typeof ReplayMissingMessagesForEndpointResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.GetEndpointTransformation
	 */
	getEndpointTransformation: {
		methodKind: "unary";
		input: typeof GetEndpointTransformationRequestSchema;
		output: typeof GetEndpointTransformationResponseSchema;
	};
	/**
	 * @generated from rpc webhooks.v1.WebhooksService.SetEndpointTransformation
	 */
	setEndpointTransformation: {
		methodKind: "unary";
		input: typeof SetEndpointTransformationRequestSchema;
		output: typeof SetEndpointTransformationResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_webhooks_v1_service, 0);
